/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
// @ts-ignore
import type { Advisor } from "../model"
/**
 * CollaboratorResourceApi - axios parameter creator
 */
export const CollaboratorResourceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get collaborator by regis role id
     * @param {string} regisRoleId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    getCollaborator: async (
      regisRoleId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'regisRoleId' is not null or undefined
      assertParamExists("getCollaborator", "regisRoleId", regisRoleId)
      const localVarPath = `/collaborators/{regisRoleId}`.replace(
        "{regisRoleId}",
        encodeURIComponent(String(regisRoleId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * CollaboratorResourceApi - functional programming interface
 */
export const CollaboratorResourceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CollaboratorResourceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get collaborator by regis role id
     * @param {string} regisRoleId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async getCollaborator(
      regisRoleId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Advisor>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCollaborator(
        regisRoleId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["CollaboratorResourceApi.getCollaborator"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * CollaboratorResourceApi - factory interface
 */
export const CollaboratorResourceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = CollaboratorResourceApiFp(configuration)
  return {
    /**
     *
     * @summary Get collaborator by regis role id
     * @param {CollaboratorResourceApiGetCollaboratorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    getCollaborator(
      requestParameters: CollaboratorResourceApiGetCollaboratorRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Advisor> {
      return localVarFp
        .getCollaborator(requestParameters.regisRoleId, options)
        .then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for getCollaborator operation in CollaboratorResourceApi.
 */
export interface CollaboratorResourceApiGetCollaboratorRequest {
  readonly regisRoleId: string
}

/**
 * CollaboratorResourceApi - object-oriented interface
 */
export class CollaboratorResourceApi extends BaseAPI {
  /**
   *
   * @summary Get collaborator by regis role id
   * @param {CollaboratorResourceApiGetCollaboratorRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  public getCollaborator(
    requestParameters: CollaboratorResourceApiGetCollaboratorRequest,
    options?: RawAxiosRequestConfig
  ) {
    return CollaboratorResourceApiFp(this.configuration)
      .getCollaborator(requestParameters.regisRoleId, options)
      .then(request => request(this.axios, this.basePath))
  }
}
